import React, { useState } from "react";
import closeIcon from "../../images/close_btn.svg";
import signupcheck from '../../images/payment_success.svg';
import backIcon from '../../images/back.svg';
import AddressForm from "./AddressForm";
import CartItem from "./CartItem";
import "./ecommerce.scss";
import PaymentForm from "./PaymentForm";

const Cart = ({ cartItems, updateCartPrice, updateProductSize, updateProductPharmacy, setCartOpen, deleteCartItem, clearCart }) => {
    const [nextScreen, setNextScreen] = useState('cart');
    const [productsData, setProductsData] = useState(null);
    const [cartError, setCartError] = useState(null);

    const handleNext = () => {
        const missingItems = cartItems
            ? cartItems.filter(item =>
                (item.Pharmacies.length > 0 && !item.selectedPharmacy) ||
                (item.Sizes.length > 0 && !item.selectedSize)
            ).map(item => item.ProductID)
            : [];

        if (missingItems.length > 0) {
            setCartError(missingItems);
            return;
        }

        setCartError(null);
        setNextScreen('addressinfo');
    };

    const handleSizeChange = (itemId, size) => {
        updateProductSize(itemId, size);
        setCartError(prevErrors => prevErrors?.filter(id => id !== itemId) || null);
    };

    const handlePharmacyChange = (itemId, pharmacy) => {
        updateProductPharmacy(itemId, pharmacy);
        setCartError(prevErrors => prevErrors?.filter(id => id !== itemId) || null);
    };

    const handleBack = () => {
        if (nextScreen === 'addressinfo') {
            setNextScreen('cart');
        } else if (nextScreen === 'payment') {
            setNextScreen('addressinfo');
        } else {
            setNextScreen('cart');
        }
    }

    const onSubmitAddressForm = (values) => {
        setProductsData(values)
        setNextScreen('payment')
    }

    const gotoAddressForm = () => {
        setNextScreen('addressinfo')
    }

    const handlePaymentSuccess = () => {
        setNextScreen('success')
        clearCart()
    }

    return (
        <div className="cart-sidebar">
            <div className="cart-header">
                {nextScreen !== 'cart' && nextScreen !== 'success' ? <div className="back"><img src={backIcon} alt="back" onClick={handleBack} /></div> : null}
                {nextScreen !== 'success' ? <h3><span>Shopping Cart</span>{cartItems && cartItems.length && nextScreen === 'cart' ? <button className="btn-primary" onClick={clearCart}>Clear Cart</button> : null}</h3> : null}
                <button className="close-cart" onClick={() => setCartOpen(false)}>
                    <img src={closeIcon} alt="Close Cart" />
                </button>
                {cartItems && cartItems.length ? <h4>{nextScreen === 'cart' ? 'My Products' : nextScreen === 'addressinfo' ? 'Shipping Information' : nextScreen === 'payment' ? 'Summary & Payment' : null}</h4> : null}
            </div>

            {cartItems && cartItems.length ? (
                <>
                    {nextScreen === 'cart' ? (
                        <>
                            <ul className="cart-items">
                                {cartItems.map((item, index) => (
                                    <CartItem
                                        key={index}
                                        item={item}
                                        updateCartPrice={updateCartPrice}
                                        updateProductSize={handleSizeChange}
                                        updateProductPharmacy={handlePharmacyChange}
                                        deleteCartItem={deleteCartItem}
                                        isError={cartError?.includes(item.ProductID)}
                                    />
                                ))}
                            </ul>
                            {cartError && cartError.length > 0 && (
                                <p className="error cart-error">
                                    Please select a pharmacy/size for the highlighted items.
                                </p>
                            )}
                        </>
                    ) : null}

                    {nextScreen === 'addressinfo' ? <AddressForm onSubmit={onSubmitAddressForm} gotoCart={() => setNextScreen('cart')} /> : null}
                    {nextScreen === 'payment' ? <PaymentForm productsData={productsData} cartItems={cartItems} paymentFormData={window.Square.payments} gotoAddressForm={gotoAddressForm} handlePaymentSuccess={handlePaymentSuccess} gotoCart={() => setNextScreen('cart')} /> : null}

                    {nextScreen === 'cart' ? <div className="cart-btns">
                        <button className="btn-primary" onClick={handleNext}>Next</button>
                    </div> : null}
                </>
            ) : nextScreen === 'success' ? <div className="success-msg">
                <img src={signupcheck} alt="" />
                <h3>Thank you for your payment.</h3>
                <p>You will receive an email with your<br />receipt and shipping details</p>
            </div> : (<p>No item(s) added yet</p>)}
        </div>
    );
};

export default Cart;
